export const TILE_SIZE = 100;



//////////////////
// WEBPACK FOOTER
// ./src/opts.ts
// module id = 0
// module chunks = 0